<template>
  <div class="edit-texture">
    <el-upload
      class="logoImg"
      list-type="picture-card"
      multiple
      action
      :on-remove="remove"
      :one-third="false"
      :auto-upload="false"
      :file-list="fileList"
      :show-file-list="true"
      :http-request="uploadImg"
      :on-change="handleChange"
    >
      <!-- <img
        src="https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
        alt=""
      /> -->
      <!-- <div class="mask" v-if="uploadFlag">
        <el-progress
          type="circle"
          :width="100"
          :percentage="uploadPercentage"
          status="success"
          style="margin-top: 15%; z-index: 100"
        ></el-progress>
      </div> -->
    </el-upload>
    <p @click="uploadImg" class="upload-btn">上传纹理</p>
  </div>
</template>

<script>
import { getOSSAuthHeritageModelTexture_Api } from "@/apis/oss.api";
export default {
  data() {
    return {
      fileList: [],
      model_name: "",
      readyFiles: [],
    };
  },
  mounted() {
    this.fileList = this.model.texture.map((item) => {
      return {
        url: item,
      };
    });

    console.log(this.model_name, this.fileList, this.$uuid.v1());
  },
  // watch: {
  //   model() {
  //     this.fileList = this.model.texture;
  //     let arr = this.model.src.split("/");
  //     this.model_name = arr[arr.length - 1].slice(0, -3);
  //     console.log(this.model_name, this.fileList);
  //   },

  //   deep: true, //
  // },
  props: ["model"],
  methods: {
    remove(file, fileList) {
      this.fileList = this.fileList.filter((item) => item.uid != file.uid);
      console.log(file, fileList, this.fileList);
      this.$emit("getTextures", this.fileList);
    },
    handleChange(file, fileList) {
      this.readyFiles.push(file);
      this.fileList.push(file);
      console.log(file, fileList, this.fileList);
    },

    async uploadImg(raw) {
      if (this.model.src) {
        let arr = this.model.src.split("/");
        this.model_name = arr[arr.length - 1].slice(0, -4);
      }
      if (!this.model_name || this.model_name == "") {
        this.$global.error(this, "需要先上传模型！", null);
        return;
      }
      if (this.readyFiles.length == 0) {
        this.$global.error(this, "没有新上传的图片！", null);
        return;
      }
      console.log(this.readyFiles, 39242934812374913298);
      let result = await getOSSAuthHeritageModelTexture_Api(this.model_name);
      console.log(result);
      for (let i = 0; i < this.readyFiles.length; i++) {
        let file_name = await (result.base_path +
          "/" +
          this.readyFiles[i].name);
        await result.oss
          .multipartUpload(file_name, this.readyFiles[i].raw)
          .then((res) => {
            console.log(res);
            this.readyFiles[i].url = res.res.requestUrls[0].split("?")[0];
            this.readyFiles[i].status = "success";
            console.log(this.readyFiles[i]);
          })
          .catch((err) => {
            this.$global.error(this, "图片上传失败！", null);
          });
      }
      await console.log(this.fileList, this.readyFiles, 123);
      this.$emit(
        "getTextures",
        this.fileList.filter((item) => item.url.indexOf("http:") != -1)
      );
    },
  },
};
</script>

<style scoped lang='scss'>
.edit-texture {
  position: relative;
  .upload-btn {
    position: absolute;
    margin-top: 10px;
    color: $timeBtn;
    font-size: 12px;
    border: 1px dotted $timeBtn;
    cursor: pointer;
  }
  .upload-btn:hover {
    color: white;
    background: $timeBtn;
  }
}
.logoImg {
  width: 290px;
  /deep/ .el-upload-list__item {
    width: 55px;
    height: 54px;
    margin-right: 2px;
    margin-bottom: 2px;
  }
  /deep/ .el-upload--picture-card {
    width: 50px;
    height: 50px;
  }
}
/deep/ .el-upload {
  position: relative;

  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    background: $maskbackground;
    top: 0px;
    left: 0px;
    .el-progress {
      position: absolute;
      z-index: 100 !important;
      left: calc(50% - 50px);
      top: calc(50% - 50px);
      margin-top: 0px !important;
      .el-icon-check:before {
        color: #67c23a;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/iHeritage/components/UploadTexture.vue